import React, { useState } from 'react';
import { View, Text, TextInput, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSquarePlus,
  faSquareMinus,
  faMagnifyingGlass,
  faXmark
} from '@fortawesome/free-solid-svg-icons';

import { elRed, elGray } from 'app/src/styles/colors';
import DataState from 'app/src/components/DataState';
import * as colors from 'app/src/styles/colors';

import { UNUSED_STOCK_NUMBERS } from './queries';

const Search = styled(View)`
  border-width: 1px;
  border-style: solid;
  border-color: black;
  margin-bottom: 10px;
  flex-direction: row;
  padding: 5px;
`;

const Input = styled(TextInput)`
  outline-width: 0px;
  outline-color: white;
  flex: 1
  margin-left: 12px;
`;

const Result = styled(View)`
  flex-direction: row;
  gap: 20px;
`;

const Unimported = ({ stockNumbers, updateStockNumbers }) => {
  const [term, setTerm] = useState('');
  const { data } = useQuery(UNUSED_STOCK_NUMBERS);

  if (!data) { return <DataState.Loading />; }

  let assets = [...data.unusedStockNumbers];
  if (term) {
    assets = assets.filter(asset => (
      asset.stockNumber.toLowerCase().includes(term.toLowerCase()) ||
        asset.name.toLowerCase().includes(term.toLowerCase())
    ))
  }

  const handleAdd = asset => {
    updateStockNumbers(asset.stockNumber, 'add');
  }

  const handleRemove = asset => {
    updateStockNumbers(asset.stockNumber, 'drop');
  };

  return (
    <View style={{minHeight: '50vh'}}>
      <Search>
        <Input
          placeholder="Search"
          placeholderTextColor={colors.disabled}
          value={term}
          onChange={e => setTerm(e.target.value)}
        />
        {term ? (
          <Pressable onPress={() => setTerm('')}>
            <FontAwesomeIcon
              icon={faXmark}
              color={colors.disabled}
            />
          </Pressable>
        ) : (
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            color={colors.disabled}
          />
        )}
      </Search>

      {assets.map(asset => (
        <Result key={asset.unitId}>
          {stockNumbers.includes(asset.stockNumber) ? (
            <FontAwesomeIcon
              icon={faSquareMinus}
              size='xl'
              style={{color: elGray}}
              onClick={() => handleRemove(asset)}
            />
          ) : (
            <FontAwesomeIcon
              icon={faSquarePlus}
              size='xl'
              style={{color: elRed}}
              onClick={() => handleAdd(asset)}
            />
          )}
          <Text>{asset.stockNumber}</Text>
          <Text>{asset.name}</Text>
        </Result>
      ))}
    </View>
  )
};

export default Unimported;
